import { OfferCard, OfferGiftCard } from '@cash-rewards/cr-ui-components';
import { ARRAY_ELEMENT_ID } from '@cash-rewards/mparticlejs';
import { clsxm } from '@cash-rewards/reactjs';
import {
  storeClickEventMapper,
  storeProductMapper,
} from '@cash-rewards/reactjs/client';

import ShopCarousel from '@/modules/core/components/shopCarousel/ShopCarousel';
import { OFFER_BADGE_MAP } from '@/modules/core/constants/badgeType';
import useFavouriteStore from '@/modules/shop/hooks/useFavouriteStore';
import { useOfferAsterisk } from '@/modules/shop/hooks/useOfferAsterisk';
import { StoreModel } from '@/modules/shop/models/offerModels';

interface TrendingStoresProps {
  stores: StoreModel[];
}

const TrendingStores = ({ stores, ...rest }: TrendingStoresProps) => {
  return (
    <ShopCarousel
      title='Trending stores'
      navigationButtonTopCss='top-14'
      data-test-id='trending-stores-carousel'
      viewAllPath='/all-stores'
      items={stores}
      productMappers={[storeProductMapper]}
      clickEventMappers={[storeClickEventMapper]}
      carouselType={ARRAY_ELEMENT_ID.trending_store}
      {...rest}
    >
      {stores.map((store) => {
        return (
          <TrendingStoreCard
            key={store.merchantId}
            store={store}
            data-test-id={`store-card-box-${store.merchantId}`}
            className='mr-cr-4 lg:mr-cr-8'
          ></TrendingStoreCard>
        );
      })}
    </ShopCarousel>
  );
};

interface TrendingStoreCardProps {
  store: StoreModel;
  className?: string;
}
const TrendingStoreCard = ({
  store,
  className,
  ...rest
}: TrendingStoreCardProps) => {
  const { isFavourite, updateFavouriteStore } = useFavouriteStore(
    store.merchantId,
    store
  );

  const isGiftCard = store.isEonxGiftCard;
  const Comp = isGiftCard ? OfferGiftCard : OfferCard;
  let badgeType;
  if (isGiftCard) {
    badgeType = OFFER_BADGE_MAP['GiftCard'];
  } else if (store.merchantBadge) {
    badgeType = OFFER_BADGE_MAP[store.merchantBadge];
  }
  const { commissionString } = useOfferAsterisk(
    store.cashbackCapDescription,
    store.firstTierMinimumSpendString,
    store.clientCommissionString
  );
  return (
    <Comp
      imageUrl={isGiftCard ? store.logoUrl : store.backgroundImageUrl}
      className={clsxm('w-[256px] ', className)}
      title={store.name}
      logoUrl={!isGiftCard ? store.logoUrl : undefined}
      aspectRatio='16:9'
      commissionString={commissionString}
      isFavourite={isFavourite}
      href={`/store/${store.hyphenatedString}`}
      badgeType={badgeType}
      onFavouriteChange={updateFavouriteStore}
      cardImageAs='img'
      {...rest}
    ></Comp>
  );
};

export default TrendingStores;
